import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCollectionCallHistory extends Layout {
    checkboxIncludeCallDetail: Checkbox;
    checkboxPageBreak: Checkbox;
    checkboxPrintItemsWithBalanceOnly: Checkbox;
    checkboxPrintOpenCalls: Checkbox;
    excludabletextboxCustomer: ExcludableTextbox;
    sourceCollectionCallHistory: DataSource;
    textboxCallDate: Textbox;
    textboxCaller: Textbox;
    textboxGroupBy: Textbox;
    textboxUser: Textbox;
}
